import React from 'react'
import Stack, {StackProps} from '@mui/material/Stack'
import styled from 'styled-components'
import boxStyles from './stack.styles'

interface ApStackProps extends StackProps {
  ap_type: 'row' | 'column'
  ap_display?: 'none'
}
const apAtomName = {ap_atom_name: 'stackAtom'}

const StackAtom = styled((props: ApStackProps) => {
  return <Stack {...apAtomName} {...props} />
})`
  ${boxStyles}
`

export default StackAtom
